export const INVOICE_NOTIFICATION_DRIVER = {
    EMAIL: 'email',
    SMS: 'sms',
    LETTER: 'letter',
    EINVOICING: 'einvoicing',
} as const;

export type InvoiceNotificationDriver = Enum<typeof INVOICE_NOTIFICATION_DRIVER>;
